import { apiClient, type PackageCategoryEntity } from '@/libs/api'
import type { PackageCategoriesRequestQuery } from '@/libs/api/types'

export type FetchPackageCategoriesQuery = {
  tenantKey: string
  query?: PackageCategoriesRequestQuery
}

export type FetchPackageCategoriesResponse = {
  data: PackageCategoryEntity[]
}

/**
 * 荷姿一覧を取得（ページングなし）
 */
export const fetchPackageCategories = async (
  { tenantKey, query }: FetchPackageCategoriesQuery,
  signal?: AbortSignal
): Promise<FetchPackageCategoriesResponse> => {
  const { data } = await apiClient._tenant(tenantKey).package_categories.$get({
    query,
    config: {
      signal
    }
  })
  return {
    data
  }
}
